import { RoutineConfig } from '../routineConfig';
import { WorkflowPageConfig } from './workflowPageConfig';

export interface WorkflowRoutineConfig extends RoutineConfig {
  pages: WorkflowPageConfig[];
}
